// ENTITY com.ic2.auth.mfa.TotpEnrolmentDTO generated by ic2 4.0.0-SNAPSHOT at Thu Oct 01 15:16:30 UTC 2026

import { mapping, fields } from '@ic2/ic2-lib';
import { LoginResponse } from './LoginResponse';

export class TotpEnrolmentDTO {

  static readonly __ic2_fqn: string = 'com.ic2.auth.mfa.TotpEnrolmentDTO';

  login: LoginResponse | null = null;
  backupCodes: string[] | null = [];

  constructor(init?:Partial<TotpEnrolmentDTO>) {
    Object.assign(this, init);
  }

  toString() {
    return JSON.stringify(this);
  }

}

mapping['com.ic2.auth.mfa.TotpEnrolmentDTO'] = TotpEnrolmentDTO;

fields['com.ic2.auth.mfa.TotpEnrolmentDTO']  = {
    login: 'com.ic2.services.dto.LoginResponse',
    backupCodes: 'java.util.List<java.lang.String>'
};
